import * as React from "react";
import type { SVGProps } from "react";
const SvgParkingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M1.12 3.72V23.4h2.24v-1.12H2.24V4.84h6.72v17.44H7.84v1.12h3.36v-1.12h-1.12V4.84h7.84v17.44H16.8v1.12h3.36v-1.12h-1.12V4.84h6.72v17.44h-1.12v1.12h2.24V3.72zm10.64 5.04v6.16h1.12v-2.8h1.61c1.67 0 1.75-1.415 1.75-1.68s-.08-1.68-1.75-1.68zm1.12 1.12h1.61c.265 0 .63 0 .63.56s-.365.56-.63.56h-1.61z"
    />
  </svg>
);
export default SvgParkingIcon;
